import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listPartners, deletePartner } from "../../../api/cms";

export default function AdminPartners() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = () => {
    setLoading(true);
    listPartners()
      .then(setPartners)
      .catch(() => setError("Failed to load partners"))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this partner?")) return;
    await deletePartner(id);
    load();
  };

  if (loading) return <p>Loading…</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Partners</h1>
        <Link to="/admin/partners/new" className="bg-bahyellow rounded px-4 py-2 text-sm font-semibold hover:opacity-90">
          + Add partner
        </Link>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Link</th>
              <th className="px-4 py-3 font-semibold">Logo</th>
              <th className="px-4 py-3" />
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {partners.map((p) => (
              <tr key={p.id}>
                <td className="px-4 py-3">{p.name}</td>
                <td className="px-4 py-3 text-blue-600 truncate max-w-xs"><a href={p.link} target="_blank" rel="noopener noreferrer">{p.link}</a></td>
                <td className="px-4 py-3"><img src={p.logo} alt={p.name} className="h-8 object-contain" /></td>
                <td className="px-4 py-3 text-right space-x-3 whitespace-nowrap">
                  <Link to={`/admin/partners/${p.id}/edit`} className="text-blue-600 hover:underline">Edit</Link>
                  <button onClick={() => handleDelete(p.id)} className="text-red-500 hover:underline">Delete</button>
                </td>
              </tr>
            ))}
            {partners.length === 0 && (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-gray-400">No partners yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
